import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchApiData = createAsyncThunk('apiData/fetchApiData', async ({ url, itemKey, params = {} }) => {
    
    try {
        const response = await axios.get(url, params)
        //console.log("itemKey", itemKey , "response", url , params)
        return {
            clef : itemKey,
            data : response.data
        }
    } catch (error) {
        console.error("Error fetching data:", error);
        throw error
    }
})


const apiDataSlice = createSlice({
    name: 'apiData',
    initialState: {
        data: {},
        loading: {},
        error: {}
    },
    reducers: {
        setLoading: (state, action) => {
            const { key, value } = action.payload;
            state.loading[key] = value;
        },
        clearError: (state, action) => {
            const key = action.payload;
            if (state.error[key]) delete state.error[key];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchApiData.pending, (state, action) => {
            const key = action.meta.arg.itemKey;
            if (key) {
                state.loading[key] = true;
                state.error[key] = null;
            }
        })
        builder.addCase(fetchApiData.fulfilled, (state, action) => {
            const key = action.meta.arg.itemKey;
            if (key) state.loading[key] = false;
            state.data[action.payload.clef] = action.payload.data;
        })
        builder.addCase(fetchApiData.rejected, (state, action) => {
            const key = action.meta.arg.itemKey;
            if (key) {
                state.loading[key] = false;
                state.error[key] = action.error.message || "Une erreur est survenue lors de la connexion.";
            }
        })
    }
})

export const { setLoading } = apiDataSlice.actions

export default apiDataSlice.reducer
